import { isNullOrUndefined } from '@/helpers'
import lodash from 'lodash'

export const rules = {
  required: msg => value => !!value || msg || 'Trường bắt buộc.',
  email: msg => value =>
    isNullOrUndefined(value) || /.+@.+\..+/.test(value) || msg || 'Email không hợp lệ',
  minLength: msg => value =>
    isNullOrUndefined(value) || value.length >= 6 || msg || 'Độ dài tối thiểu 6 kí tự',
  maxLength: msg => value =>
    isNullOrUndefined(value) || value.length <= 20 || msg || 'Độ dài tối đa 6 kí tự',
  minValue: (min, msg) => value =>
    isNullOrUndefined(value) || isNaN(parseFloat(value))
      ? 'Phải là số'
      : parseFloat(value) < min
      ? msg || `Giá trị tối thiểu là ${min}`
      : true,
  maxValue: (max, msg) => value =>
    isNullOrUndefined(value) || isNaN(parseFloat(value))
      ? 'Phải là số'
      : parseFloat(value) > max
      ? msg || `Giá trị tối đa là ${max}`
      : true
}
export const colors = [
  '#228b22', // Darker Lime Green
  '#0080bf', // Darker Deep Sky Blue
  '#6a5acd', // Darker Medium Purple
  '#cc7000', // Darker Dark Orange
  '#cc5a99', // Darker Hot Pink
  '#cc4f3b', // Darker Tomato
  '#606060', // Darker Gray
  '#a0a0a0', // Darker Light Gray
  '#cca982', // Darker Peach Puff
  '#1565d8', // Darker Dodger Blue
  '#00cc00', // Darker Lime
  '#cc8400', // Darker Orange
  '#005bbf', // Darker Blue
  '#177f6b', // Darker Light Sea Green
  '#ccad00', // Darker Gold
  '#7a7a7a', // Darker Dark Gray
  '#731fa6', // Darker Dark Orchid
  '#cc3700', // Darker Orange Red
  '#5fa0cc', // Darker Sky Blue
  '#9623a8' // Darker Medium Orchid
]
